export default "__VITE_PUBLIC_ASSET__514f5cc9__"